import { createSlice } from '@reduxjs/toolkit';

const accountSlice = createSlice({
  name: 'account',
  initialState: {
    employeeVo: {},
    register: true,
    globalPosition: 'KR',
    isSendOtp: false,
    isCheckOtp: false,
    isAuthSuccess: false,
    isUpdateEmployee: false,
    incorrectOTPcount: 0,
  },
  reducers: {
    getNoSessionRegister: () => {},
    getNoSessionRegisterSuccess: (state, { payload }) => {
      state.register = payload.value === 'N';
    },
    getNoSessionGlobalPosition: () => {},
    getNoSessionGlobalPositionSuccess: (state, { payload }) => {
      state.globalPosition = payload.value;
    },
    getNewEmployee: state => {
      state.incorrectOTPcount = 0;
      state.isSendOtp = false;
    },
    getNewEmployeeSuccess: (state, { payload }) => {
      state.employeeVo = payload;
      state.incorrectOTPcount = 0;
      state.isSendOtp = true;
    },
    getNewEmployeeFail: (state, { payload }) => {
      state.employeeVo = payload;
    },
    setIsSendOtp: (state, { payload }) => {
      state.isSendOtp = payload;
    },
    checkOtp: state => {
      state.isAuthSuccess = false;
    },
    checkOtpSuccess: (state, { payload }) => {
      state.isAuthSuccess = payload;
    },
    checkOtpFail: (state, { payload }) => {
      state.incorrectOTPcount += 1;
      state.isAuthSuccess = false;
    },
    updateEmployee: state => {
      state.isUpdateEmployee = false;
    },
    updateEmployeeSuccess: (state, { payload }) => {
      state.isUpdateEmployee = true;
    },
    updateEmployeeFail: (state, { payload }) => {
      state.isUpdateEmployee = false;
    },
  },
});

export const {
  getNoSessionRegister,
  getNoSessionRegisterSuccess,
  getNoSessionGlobalPosition,
  getNoSessionGlobalPositionSuccess,
  getNewEmployee,
  getNewEmployeeSuccess,
  getNewEmployeeFail,
  setIsSendOtp,
  checkOtp,
  checkOtpSuccess,
  checkOtpFail,
  updateEmployee,
  updateEmployeeSuccess,
  updateEmployeeFail,
} = accountSlice.actions;
export default accountSlice.reducer;
